"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeliverrUser = void 0;
const lodash_1 = require("lodash");
const getDeliverrUser = (cognitoAttrs) => {
    const formattedData = (0, lodash_1.mapKeys)(cognitoAttrs, (_, key) => (0, lodash_1.camelCase)(key.replace(/(custom):/, "")));
    const { name, company, phoneNumber, email, listingTool, isCatalogImported, hasChargebeeAccount, onboardingStage, sellerIds, algoliaSearchKey, updatedAt, sellerUniqueId, resultsPerPage, dealStage, source, activatedFastTag, } = formattedData;
    const sellerId = sellerIds && (sellerIds.split(",")[0] || "");
    const groups = cognitoAttrs["cognito:groups"];
    const coaleseBool = (value) => ((0, lodash_1.isString)(value) ? value === "true" : value);
    return {
        name,
        company,
        phoneNumber,
        email,
        listingTool,
        algoliaSearchKey,
        hasChargebeeAccount: coaleseBool(hasChargebeeAccount),
        isCatalogImported: coaleseBool(isCatalogImported),
        isAdmin: Boolean(groups && groups.includes("admin")),
        onboardingStage: onboardingStage ? JSON.parse(onboardingStage) : {},
        sellerId,
        groups,
        sellerUniqueId: sellerUniqueId ? sellerUniqueId : sellerId,
        updatedAt: new Date(+updatedAt),
        resultsPerPage: resultsPerPage ? JSON.parse(resultsPerPage) : {},
        dealStage,
        source,
        activatedFastTag: coaleseBool(activatedFastTag),
    };
};
exports.getDeliverrUser = getDeliverrUser;
//# sourceMappingURL=DeliverrUser.js.map